// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"13":"4f78858d","465":"373b0116","755":"c4378e4f"}[chunkId] + ".js";
};